import React from 'react';
import styles from './index.module.scss';
import { ctLogV2 } from '../../../utils/cleverTapLogger.utils';
import { useIdHash } from '../../../hooks/custom.hooks';

function DetialsPage({
  setIsOpen,
  store,
  detailsData,
  listData,
  setDetailsData,
}) {
  const categoryTnc =
    listData?.categories?.find(
      (cat) => cat.type.toLowerCase() === store.toLowerCase(),
    )?.tnc || [];
  const { custId: cid } = useIdHash();

  return (
    <div className={styles.detailsSection}>
      <div className={styles.brandDetails}>
        <div className={styles.nameSection}>
          <div className={styles.merchantType}>{store} STORE</div>
          <div className={styles.brandName}>{detailsData?.name}</div>
          <div className={styles.offer}>{detailsData?.discount}</div>
        </div>

        <div className={styles.imgSection}>
          <img src={detailsData?.logo_square} alt="" />
        </div>
      </div>

      <div className={styles.instructionSection}>
        <div className={styles.heading}>
          <span>How to pay with rewards?</span>
          <div></div>
        </div>
        <div className={styles.insturction}>
          {categoryTnc.map((elem, index) => {
            return (
              <div key={elem?.key} className={styles.title}>
                <div>
                  {index + 1}. {''}
                  {elem?.text}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.buttonContainer}>
        {detailsData?.redirection_url && (
          <button
            className={styles.closeButton}
            onClick={() => {
              setIsOpen(false);
              setDetailsData(null);
            }}
            style={{ width: '92px' }}
          >
            Close
          </button>
        )}
        <button
          className={styles.button}
          onClick={() => {
            ctLogV2({
              eventName: 'appMerchantListingVisitStoreClicked',
              customerId: cid,
              extraData: {
                merchant_name: detailsData?.name,
                category_name: store.toLowerCase(),
              },
            });
            if (detailsData?.redirection_url) {
              window.open(detailsData.redirection_url, '_blank');
            } else {
              setIsOpen(false);
              setDetailsData(null);
            }
          }}
          style={{
            width: detailsData?.redirection_url ? 'calc(100% - 92px)' : '100%',
          }}
        >
          {detailsData?.redirection_url ? 'VISIT STORE' : 'OK, Got it'}
        </button>
      </div>
    </div>
  );
}

export default DetialsPage;
